<template>
  <div>
     <v-container>
      <v-card v-if="!$store.getters.pagesFormStatus && !$store.getters.pagePublishRequest">
        <v-card-title>
          <div class="w-100 d-flex flex-row justify-content-between">
            <div>  صفحات </div>
            <div>
              <v-btn
                class="mx-1 float-left"
                color="primary"
                @click.stop="openCreateOrEditDialog()"
                >   صفحه جدید</v-btn
              >
              <v-btn
                class="mx-1 float-left"
                color="primary"
                @click.stop="openPublishRequestPage()"
                >لیست درخواست های انتشار</v-btn
              >
            </div>
          </div>
        </v-card-title>
        <v-divider> </v-divider>
        <v-card-text>
          <pages-list> </pages-list>
        </v-card-text>
      </v-card>
      <pages-form v-else-if="$store.getters.pagesFormStatus && !$store.getters.pagePublishRequest"> </pages-form>
      <publish-request-pages-list v-else-if="!$store.getters.pagesFormStatus && $store.getters.pagePublishRequest"></publish-request-pages-list>
    </v-container>
  </div>
</template>

<script>
// import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import PagesForm from "../components/PagesForm.vue";
import PagesList from "../components/PagesList.vue";
import PublishRequestPagesList from '../components/PublishRequestPagesList.vue';
export default {
  components: {
    PagesList,
    PagesForm,
    PublishRequestPagesList
  },
  
   methods: {
    openCreateOrEditDialog() {
      this.$store.commit("setPagesFormStatus", true);
    },
    openPublishRequestPage(){
      this.$store.commit("setPagePublishRequest", true);
    }
  },
   mounted() {
    // this.$store.dispatch(SET_BREADCRUMB, [{ title: "صفحات" }]); 
  },
};
</script>

<style lang="scss" scoped>
</style>